import { initializeApp } from 'firebase/app'
import { initializeAppCheck, ReCaptchaEnterpriseProvider, ReCaptchaV3Provider } from 'firebase/app-check'
import { ref, getDatabase } from 'firebase/database'
import { createContext } from 'react'
// import { storeUserId } from './storeToLocalStorage'
// import { mod1271_36 } from "cdigit";

const isDev = window.location.hostname === 'localhost'

;(window as any).FIREBASE_APPCHECK_DEBUG_TOKEN = isDev

const app = initializeApp({
  databaseURL: 'https://kaffeerechner.europe-west1.firebasedatabase.app/',
  apiKey: 'AIzaSyDj4VVmQgxfq-59EBB4pZUVBZOOiE_FsPE',
  authDomain: 'captchadatabases.firebaseapp.com',
  projectId: 'captchadatabases',
  storageBucket: 'captchadatabases.appspot.com',
  messagingSenderId: '78621128630',
  appId: '1:78621128630:web:5b1182f6b86e20765df317',
})
// reCaptcha c3
const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaEnterpriseProvider("6LffZUYqAAAAAM4Fsz5zOSSAqM_6qan1Wy5Oj9Dh"), 
  isTokenAutoRefreshEnabled: true,
});
// Get a reference to the database service and provide it via context
const db = getDatabase(app)

const drinksmix = ref(db, 'drinksmix')
const drinks = ref(db, 'drinks')
const bycaffeine = ref(db, 'bycaffeine')
const byportioncount = ref(db, 'byportioncount')
const dbRef = ref(db)

export const firebaseContext = createContext({
  drinks,
  drinksmix,
  bycaffeine,
  byportioncount,
  dbRef,
  db,
})
